import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "20",
  height: "21",
  viewBox: "0 0 20 21",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "clip-rule": "evenodd",
      d: "M1.667 3.753a2 2 0 0 1 2-2h12.666a2 2 0 0 1 2 2v12.666a2 2 0 0 1-2 2H3.667a2 2 0 0 1-2-2V3.753z",
      stroke: "currentColor",
      "stroke-width": "1.2"
    }, null, -1),
    _createElementVNode("path", {
      d: "M7.385 14.086v-7.7h3.333c.69 0 1.283.114 1.782.341.498.22.883.539 1.155.957.271.418.407.917.407 1.496 0 .572-.136 1.067-.407 1.485-.272.418-.657.74-1.155.968-.499.22-1.093.33-1.782.33H8.375l.792-.803v2.926H7.385zm1.782-2.728-.792-.847h2.244c.55 0 .96-.117 1.232-.352.271-.235.407-.561.407-.979 0-.425-.136-.755-.407-.99-.272-.235-.682-.352-1.232-.352H8.375l.792-.847v4.367z",
      fill: "currentColor"
    }, null, -1)
  ]))]))
}
export default { render: render }